import { render } from "./control.vue?vue&type=template&id=854ae816&scoped=true&ts=true"
import script from "./control.vue?vue&type=script&setup=true&lang=ts"
export * from "./control.vue?vue&type=script&setup=true&lang=ts"

import "./control.vue?vue&type=style&index=0&id=854ae816&scoped=true&lang=scss"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854ae816"],['__file',"src/views/data-manage/dataset/control.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "854ae816"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('854ae816', __exports__)) {
    console.log('reload')
    api.reload('854ae816', __exports__)
  }
  
  module.hot.accept("./control.vue?vue&type=template&id=854ae816&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('854ae816', render)
  })

}


export default __exports__